// extracted by mini-css-extract-plugin
export default {"productCarousel":"X0-z"};